import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Form } from 'antd';

import Input from 'components/Common/Input';

const { Item } = Form;

const PositionsForm = ({ form, onSubmit }) => (
  <Form layout="vertical" form={form} onFinish={onSubmit}>
    <Item
      label="Title"
      name="title"
      rules={[
        {
          required: true,
          message: 'Required field',
        },
      ]}
    >
      <Input />
    </Item>
    <Item
      label="Delivery"
      name="is_delivery"
      rules={[
        {
          required: true,
          message: 'Required field',
        },
      ]}
      initialValue={false}
      valuePropName="checked"
    >
      <Switch />
    </Item>
  </Form>
);

PositionsForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PositionsForm;
